<template>
    <Frame>
     <PageHeader class="page-header" :title="title" :hasBack="true" detailType="qmAbnQlyOrderDetail"/>
     <div class="detail-contain" v-loading="tableLoading">
        <div class="Header" ref="Header">
            <div class="head-row">
                <span class="title">{{ $t('qmAbnQlyOrderDetail.QmAbnQlyOrderInfo') }}</span>
                <div class="button-group">
                    <el-button type="text" :disabled="edit" :class="edit?'button unoption-icon':'button option-icon'" @click="billedit()"><svg-icon icon-class="edit" />{{$t('button.modification')}}</el-button>
                    <el-button type="text" :disabled="!edit" :class="!edit?'button unoption-icon':'button option-icon'" @click="billsave()"><svg-icon icon-class="save" />{{$t('button.save')}}</el-button>
                    <el-button type="text" :disabled="edit" :class="edit?'button unoption-icon':'button option-icon'" @click="accDownLoad()"><svg-icon icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
                    <el-button type="text" :disabled="edit" :class="edit?'button unoption-icon':'button option-icon'" id="print" @click="printdialog()"><svg-icon icon-class="print" />{{$t('button.print')}}</el-button>
                </div>
            </div>
            <div class="head-row" style="justify-content: left;">
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.BillNo') }}：{{ BillNo }}</div>
                <div class="head-info-cell">{{ $t('Order.messagedate') }}：{{ BillDate }}</div>
                <div class="head-info-cell" v-if="$store.state.ShowComp">{{ $t('Order.compName') }}：{{ FOrgName }}</div>
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.DangerLvId') }}：<span :class="'DangerLv'+DangerLv">{{ DangerNm }}</span></div>
      
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.DiscoveryDate') }}：{{ DiscoveryDate }}</div>
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.ReplayDate') }}：{{ ReplayDate }}</div>
                <div class="head-info-cell">{{ $t('OrderExecution.product') }}：{{ MaterialName }}</div>
                <div class="head-info-cell">{{ $t('OrderDetail.specifications') }}：{{ MaterialSpec }}</div>
     
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.DefectiveQty') }}：{{ DefectiveQty }}</div>
                <div v-if="$store.state.ShowBatchNo" class="head-info-cell">{{ $t('QmAbnQlyOrder.BatchNo') }}：{{ BatchNo }}</div>
                <div v-if="$store.state.ShowBatchNo" class="head-info-cell">{{ $t('qmAbnQlyOrderDetail.SubBatchNo') }}：{{ SubBatchNo }}</div>
                <div class="head-info-cell" v-if="$store.state.ShowMTO">{{ $t('QmAbnQlyOrder.MTONo') }}：{{ MTONo }}</div>
        
                <div class="head-info-cell">{{ $t('QmAbnQlyOrder.ExcpDescribe') }}：{{ ExcpDescribe }}</div>
            </div>
            <div class="head-row">
                <div class="head-info-cell">{{ $t('qmAbnQlyOrderDetail.ExcpDescribeACC') }}   
                    <el-button class="body-button" @click="accUpLoad('ExcpDescribe')" v-if='edit'><svg-icon class="btn-icon" icon-class="uploadFileSelected" />{{$t('qmAbnQlyOrderDetail.UpAcc')}}</el-button>
                    <el-button class="body-button" @click="accDownLoad('ExcpDescribe')" v-if='!edit'><svg-icon class="btn-icon" icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
                </div>
             
            </div>
        </div>
        <div class="cutline"></div>
        <div class="body" ref="body">
            <span class="body-title">{{ $t('qmAbnQlyOrderDetail.SupplierReplyInfo') }}</span>
            <div class="body-row">
                <span class="body-textlabel">{{ $t('qmAbnQlyOrderDetail.CauseReason') }}</span>
                <span class="body-textinfo" v-if='!edit'>{{ CauseReason }}</span>
                <el-input resize="none" v-if='edit' class="body-textarea" type="textarea" :rows="3" maxlength="400" :placeholder=" $t('qmAbnQlyOrderDetail.placeholder')" v-model="CauseReason"></el-input>
                <el-button class="body-button" @click="accUpLoad('CauseReason')" v-if='edit'><svg-icon class="btn-icon" icon-class="uploadFileSelected" />{{$t('qmAbnQlyOrderDetail.UpAcc')}}</el-button>
                <el-button class="body-button" @click="accDownLoad('CauseReason')"  v-if='!edit'><svg-icon class="btn-icon" icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
            </div>
            <div class="body-row">
                <span class="body-textlabel">{{ $t('qmAbnQlyOrderDetail.OutflowReason') }}</span>
                <span class="body-textinfo" v-if='!edit'>{{ OutflowReason }}</span>
                <el-input resize="none"  v-if='edit' class="body-textarea" type="textarea" :rows="3" maxlength="400"  :placeholder=" $t('qmAbnQlyOrderDetail.placeholder')" v-model="OutflowReason"></el-input>
                <el-button class="body-button" @click="accUpLoad('OutflowReason')" v-if='edit'><svg-icon class="btn-icon" icon-class="uploadFileSelected" />{{$t('qmAbnQlyOrderDetail.UpAcc')}}</el-button>
                <el-button class="body-button" @click="accDownLoad('OutflowReason')" v-if='!edit'><svg-icon class="btn-icon" icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
            </div>
            <div class="body-row">
                <span class="body-textlabel">{{ $t('qmAbnQlyOrderDetail.TempMeasure') }}</span>
                <span class="body-textinfo" v-if='!edit'>{{ TempMeasure }}</span>
                <el-input resize="none" v-if='edit' class="body-textarea" type="textarea" :rows="3" maxlength="400"  :placeholder=" $t('qmAbnQlyOrderDetail.placeholder')" v-model="TempMeasure"></el-input>
                <el-button class="body-button" @click="accUpLoad('TempMeasure')" v-if='edit'><svg-icon class="btn-icon" icon-class="uploadFileSelected" />{{$t('qmAbnQlyOrderDetail.UpAcc')}}</el-button>
                <el-button class="body-button" @click="accDownLoad('TempMeasure')" v-if='!edit'><svg-icon class="btn-icon" icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
            </div>
            <div class="body-row">
                <span class="body-textlabel">{{ $t('qmAbnQlyOrderDetail.LongTermMeasure') }}</span>
                <span class="body-textinfo" v-if='!edit'>{{ LongTermMeasure }}</span>
                <el-input resize="none" v-if='edit' class="body-textarea" type="textarea" :rows="3" maxlength="400"  :placeholder=" $t('qmAbnQlyOrderDetail.placeholder')" v-model="LongTermMeasure"></el-input>
                <el-button class="body-button" @click="accUpLoad('LongTermMeasure')" v-if='edit'><svg-icon class="btn-icon" icon-class="uploadFileSelected" />{{$t('qmAbnQlyOrderDetail.UpAcc')}}</el-button>
                <el-button class="body-button" @click="accDownLoad('LongTermMeasure')" v-if='!edit'><svg-icon class="btn-icon" icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
            </div>
            <div class="body-row" >
                <span class="body-textlabel" style="padding-top:0">{{ $t('qmAbnQlyOrderDetail.InfoUpload') }}</span>
                <el-button class="body-button" style="margin: 0;" @click="accUpLoad('OrderAcc')" v-if='edit'><svg-icon class="btn-icon" icon-class="uploadFileSelected" />{{$t('qmAbnQlyOrderDetail.UpAcc')}}</el-button>
                <el-button class="body-button" style="margin: 0;" @click="accDownLoad('OrderAcc')" v-if='!edit'><svg-icon class="btn-icon" icon-class="downloadBillAccess" />{{$t('button.downloadAccess')}}</el-button>
            </div>
        </div>
     </div>
     <BillAccDialog :isBillAccess="true" ref="BillAccDialog"></BillAccDialog>
     <DialogUpLoad :visible.sync="uploadVisible" :base="base" ref="DialogUpLoad" :FieldName="FieldName"></DialogUpLoad>
     <DialogPrint :billno="BillNo" :progId="ProgId" ref="DialogPrint"></DialogPrint>
     </Frame>
</template>
<script>
import BillAccDialog from '@/components/BillAccDialog.vue'
import DialogPrint from '@/components/DialogPrint.vue';
import DialogUpLoad from '@/components/DialogUpLoad.vue'
export default{
    name:'QmAbnQlyOrderDetail',
    components:{BillAccDialog,DialogUpLoad,DialogPrint},
    data(){
        return {
            ProgId:'qmAbnQlyOrder',
            edit:false,
            BillNo:'',
            BillDate:'',
            FOrgId:'',
            FOrgName:'',
            DangerLvId:'',
            DangerNm:'',
            DangerLv:'',
            DiscoveryDate:'',
            ReplayDate:'',
            MaterialName:'',
            MaterialSpec:'',
            DefectiveQty:'',
            BatchNo:'',
            SubBatchNo:'',
            MTONo:'',
            ExcpDescribe:'',
            CauseReason:'',
            OutflowReason:'',
            TempMeasure:'',
            LongTermMeasure:'',
            InternalId:'',
            resizeFlag:'',
            dialogtitle:'',
            dialogvisible:false,
            dialogdata:[],
            dialogloading:false,
            base:{},
            FieldName:'',
            tableLoading:false,
            title:this.$t('comm.qmAbnQlyOrderDetail'),
            uploadVisible:false
        };
    },
    async mounted(){
        let that = this;
        window.onresize = () => {
        if (that.resizeFlag) {
            clearTimeout(that.resizeFlag);
        }
        that.resizeFlag = setTimeout(() => {
            this.$refs.body.style.height = (window.innerHeight - this.$refs.Header.clientHeight-200)+"px";
            that.resizeFlag = null;
        }, 100);
        }
        this.BillNo = this.$route.query.BillNo;
        if(this.$route.query.edit){
            this.edit = true;
        }
        await this.getorder();
        this.$refs.body.style.height = (window.innerHeight - this.$refs.Header.clientHeight-200)+"px";
    },
    methods:{
        async getorder(){
            await this.asyncaxiosInvoke("/SupplierComm/Handler/VueSysHandler.ashx",
            {
                action: "getqmabnqlyorderdetail",
                BillNo: this.BillNo,
            }, (res) => {
                var data = res.data;
                this.ProgId = data.ProgId;
                this.BillDate = data.BillDate;
                this.FOrgId = data.FOrgId;
                this.FOrgName = data.FOrgName;
                this.DangerLvId = data.DangerLvId;
                this.DiscoveryDate = data.DiscoveryDate;
                this.ReplayDate = data.ReplayDate;
                this.MaterialName = data.MaterialName;
                this.MaterialSpec = data.MaterialSpec;
                this.DefectiveQty = data.DefectiveQty;
                this.BatchNo = data.BatchNo;
                this.SubBatchNo = data.SubBatchNo;
                this.MTONo = data.MTONo;
                this.ExcpDescribe = data.ExcpDescribe;
                this.CauseReason = data.CauseReason;
                this.OutflowReason = data.OutflowReason;
                this.TempMeasure = data.TempMeasure;
                this.LongTermMeasure = data.LongTermMeasure;
                this.DangerNm = data.DangerNm;
                this.DangerLv = data.DangerLv;
                this.InternalId = data.InternalId;
                this.base = {
                    progId:this.ProgId,
                    InternalId:this.InternalId,
                    billNo:this.BillNo
                }
            })
        },
        billedit(){
        this.tableLoading = true;
        this.axiosInvoke("/SupplierComm/Handler/OrderPurPurchaseHandler.ashx", {
            action:"ispermitedit",
            ProgId:this.ProgId,
            BillNo:this.BillNo,
            },(res,errflag)=>{
            this.tableLoading = false;
            if(!errflag){
                this.edit = true;
                this.title = this.$t('comm.qmAbnQlyOrderDetailEdit');
            }
            });
    },
        billsave(){
            this.tableLoading = true;
            setTimeout(()=>{
                this.axiosInvoke("/SupplierComm/Handler/OrderPurPurchaseHandler.ashx", {
                    action:'qmabnqlyordereditsave',
                    BillNo:this.BillNo,
                    EditList:JSON.stringify([{
                        CauseReason:this.CauseReason,
                        OutflowReason:this.OutflowReason,
                        TempMeasure:this.TempMeasure,
                        LongTermMeasure:this.LongTermMeasure
                    }])

                },()=>{
                    this.tableLoading = false;
                    this.edit = false;
                    this.title = this.$t('comm.qmAbnQlyOrderDetail');
                })
           
            },100)
            
        },
        accDownLoad(fieldname){
            if(!this.edit){
                //下载附件
                let dialogtitle = this.$t('button.downloadBillAccess') + "(" + this.BillNo + ")";
                let GetType = "All";
                if(fieldname){
                    GetType = {FieldName:fieldname};
                    switch(fieldname){
                        case "ExcpDescribe":
                        dialogtitle = this.$t('qmAbnQlyOrderDetail.fieldAcc').replace("{0}",this.$t('QmAbnQlyOrder.ExcpDescribe')).replace("{1}",this.BillNo);
                            break;
                        case "CauseReason":
                        dialogtitle = this.$t('qmAbnQlyOrderDetail.fieldAcc').replace("{0}",this.$t('qmAbnQlyOrderDetail.CauseReason')).replace("{1}",this.BillNo);
                            break;
                        case "OutflowReason":
                        dialogtitle = this.$t('qmAbnQlyOrderDetail.fieldAcc').replace("{0}",this.$t('qmAbnQlyOrderDetail.OutflowReason')).replace("{1}",this.BillNo);
                            break;
                        case "TempMeasure":
                        dialogtitle = this.$t('qmAbnQlyOrderDetail.fieldAcc').replace("{0}",this.$t('qmAbnQlyOrderDetail.TempMeasure')).replace("{1}",this.BillNo);
                            break;
                        case "LongTermMeasure":
                        dialogtitle = this.$t('qmAbnQlyOrderDetail.fieldAcc').replace("{0}",this.$t('qmAbnQlyOrderDetail.LongTermMeasure')).replace("{1}",this.BillNo);
                            break;
                        case "OrderAcc":
                        dialogtitle = this.$t('button.downloadOrderAccess') + "(" + this.BillNo + ")";
                        GetType = "OrderAcc";
                            break;
                    }
                }
                this.$refs.BillAccDialog.GetAccList(this.BillNo,this.ProgId,this.InternalId,GetType,true,dialogtitle);
            }
  
        },
        accUpLoad(fieldName){
            //上传附件
            this.FieldName = fieldName;
            if(fieldName == "OrderAcc")
            this.FieldName = "";
            this.uploadVisible = true;
          
        },
        printdialog(){
            this.$refs.DialogPrint.printdialog();
        }
    }
}
</script>
<style scoped>
.page-header{
    z-index: 999;
    width: 100%;
    position: fixed;
    background-color: white;
}
.detail-contain{
    margin-top: 51px;
    padding: 10px;
}
.Header{
    width: 100%;
}
.body{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    min-height: 200px;
}
.body::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.body::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}
.Header:first-child{
    padding: 14px 0px;
}
.head-row{
    padding: 0 20px 14px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.body-row{
    width: 100%;
    padding: 0 20px 20px 20px;
    display: flex;
}
.body-row .el-button{
    padding: 10px 20px;
}
.title{
    color: #5d5d5d;
    font-size: 16px;
}
.body-title{
    padding-left: 20px;
    margin-bottom:20px;
    color: #5d5d5d;
    font-size: 16px;
}
.button {
  white-space: nowrap;
  color: #5d5d5d;
  font-size: 15px;
  cursor: pointer;
}
.button:hover {
  cursor: pointer;
  color: #0177d5;
}
.option-icon{
  filter: grayscale(100%);
  padding-right:5%;
}
.unoption-icon{
  filter: grayscale(100%);
  padding-right:5%;
  opacity: 0.5;
}
.option-icon:hover{
  filter: grayscale(0%);
}
.button-group{
    width: 400px;
    padding-right: 200px;
    display: flex;
    justify-content: space-between;
}
.head-info-cell{
    color: #777777;
    font-size: 14px;
    width: 24%;
    padding-right: 1%;
    word-break: break-all;
    padding-top: 14px;

}
.cutline{
    margin: 0 20px 20px 20px ;
    border-top: gainsboro solid 1px;
}
.body-textarea{
    width: 60%;
    padding-right: 30px;
}
.body-textlabel{
    padding-right: 20px;
    font-size: 14px;
    color: #777777;
}
.body-button{
    height: 38px;
    margin: 18.5px 0;
}
.btn-icon{
    filter: grayscale(100%);
}
.el-button:hover .btn-icon{
    filter: grayscale(0%);
}
.body-textinfo{
    width: calc( 60% - 30px );
    margin-right: 30px;
    padding: 5px 15px;
    height: 65px;
    overflow: auto;
    color: #777777;
    font-size: 14px;
    word-break: break-all;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
}
.DangerLv0{
    color: #FF3B30 ;
}
.DangerLv1{
    color: #FF9500 ;
}
.DangerLv2{
    color: #007AFF ;
}
</style>